module.exports = __webpack_public_path__ + "media/src/images/landing_icons/landing_features-05-974404110875fe267b01d2bf03599013.svg";